import React, { createContext, createRef, useMemo } from 'react';

import PropTypes from 'prop-types';

import BlockUI from '../widgets/BlockUI';
import DialogUI from '../widgets/DialogUI';
import SnackbarUI from '../widgets/SnackbarUI';

const UIContext = createContext({});

const snackbarUI = createRef();
const blockUI = createRef();
const dialogUI = createRef();

const UIProvider = (props) => {
  const rootUI = useMemo(() => {
    return {
      blockUI,
      snackbarUI,
      dialogUI,
    };
  }, []);

  return (
    <UIContext.Provider value={rootUI}>
      {props.children}
      <SnackbarUI ref={snackbarUI} />
      <BlockUI ref={blockUI} />
      <DialogUI ref={dialogUI} />
    </UIContext.Provider>
  );
};

const useUI = () => {
  return React.useContext(UIContext);
};

UIProvider.propTypes = {
  children: PropTypes.node,
};

export { UIProvider, useUI };
